import { canonicalizeLocale } from '../../locale/normalize'
import { getRegionalLocale } from '../../locale/regional'
import { bot, browser, defaultLocale, group, path, source, stored } from '../../locale/sources'

export function deserializeOlimpbetLocale(value) {
  const locale = canonicalizeLocale(value)
  return locale === 'kz' ? 'kk' : locale
}

export function serializeOlimpbetLocale(value) {
  const locale = canonicalizeLocale(value)
  return locale === 'kk' ? 'kz' : locale
}

export default function createLocalePolicy(settings) {
  const extended = (settings.configuredLocales || []).includes('uz-Cyrl')
  const explicit = group('explicit', [path(), stored()], (context) => Boolean(context.urlLocale))
  const regionalRules = { localesByRegion: { TR: 'tr', AZ: 'az', BD: 'bn', IN: 'hi', AR: 'es', CO: 'es' } }
  const regional = source('regional', (context) => getRegionalLocale(context, regionalRules))
  return {
    // Applied before locale resolution: WebView query can replace the stored choice.
    initialLocale: settings.webview ? { queryParam: 'locale', overwriteStored: true, removeFromUrl: true } : null,
    storage: {
      key: 'i18nextLng',
      fallbackKey: 'u_lang',
      deserialize: deserializeOlimpbetLocale,
      serialize: serializeOlimpbetLocale,
      authoritative: true, // Valid primary storage wins before both priority arrays.
    },
    bootstrapPriority: [explicit, bot(), stored(), browser(), defaultLocale()],
    localePriority: [explicit, bot(), stored(), regional, browser(), defaultLocale()],
    persistence: {
      bootstrapPath: settings.webview ? false : 'always',
      explicitPath: !settings.webview,
      mirror: extended && !settings.webview,
      i18n: true,
    },
    profile: { overwrite: extended, preserveStored: true },
    consumers: { i18n: 'resolved', apollo: 'resolved', rest: 'resolved' },
  }
}
